import React from "react";

const PercentageDisplay = ({ value = 100, max = 100 }) => {
  const showMax = value === max;

  let textColor = "text-color-dark-text-secondary";
  let textFont = "font-black";

  if (value === 0) {
    textColor = "text-color-raindrop-primary";
    textFont = "font-black";
  }

  if (showMax) {
    return (
      <p className={`text-sm font-black text-color-dark-text-secondary`}>MAX</p>
    );
  }

  return (
    <div className={`flex flex-row items-baseline ${textColor}`}>
      <div className={`${textFont}`}>{value}</div>
      <div className="text-xs">%</div>
    </div>
  );
};

export default PercentageDisplay;
